import React, { useState } from 'react'
import "./Home.css";
import Flip from 'react-reveal/Flip';
import Bounce from 'react-reveal/Bounce';

function Home() {
    
    return (
        <>
            <div className="home">
                <div id="carouselExampleIndicators" class="carousel   slide" data-bs-ride="carousel">
                    <div class="carousel-indicators">
                        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
                    </div>

                    <div class="carousel-inner">
                        {/* img1 */}
                        <div class="carousel-item active">


                            <img src="https://cdn1.epicgames.com/salesEvent/salesEvent/18BR_S18_Launcher_EGS_Blade_2560x1440_2560x1440-da6f6a137b90887357222b762c7675a1" class="d-block w-100" alt="..." />
                            <div className="home__img_img0">
                                <img src="https://cdn2.unrealengine.com/season-bug-en-200x200-dfb08d0feb71.png" alt="" />
                            </div>

                            <div className="home_img_display_flex">

                                <h3 className="home__img__title">
                                    SEASON 8
                                </h3>

                                <img className="home__img__img1" src="https://cdn2.unrealengine.com/cubed-logo-en-763x198-a0ecb436bcc5.png" alt="" />

                                <div className="home__image__trailer">
                                    WATCH TRAILER
                                </div>

                                <div className="home__img__playbutton">
                                    <i class="fas fa-play"></i>
                                </div>

                                <div className="home__img__playFreeNow">
                                    <h1>PLAY FREE NOW !</h1>
                                </div>
                            </div>
                        </div>

                        img2
                        <div class="carousel-item">
                            <img src="https://cdn2.unrealengine.com/18br-lineup-social-social-1920x1080-2d7d95791d77.jpg" alt="Second slide" class="d-block w-100" alt="" />
                            <div className="home__img_img0">
                                <img src="https://cdn2.unrealengine.com/season-bug-en-200x200-dfb08d0feb71.png" alt="" />
                            </div>

                            <h3 className="home__img__title">
                                SEASON 8
                            </h3>

                            <img className="home__img__img1" src="https://cdn2.unrealengine.com/cubed-logo-en-763x198-a0ecb436bcc5.png" alt="" />

                            <div className="home__image__trailer img1">
                                BATTLE PASS
                            </div>

                            <div className="home__img__playFreeNow">
                                <h1>GET BATTLE PASS </h1>
                            </div>

                        </div>


                        {/* img3 */}
                        <div class="carousel-item">
                            <img src="https://cdn2.unrealengine.com/13br-evergreens-purpink-newsheader-1920x1080-0bf253e34abd.jpg" class="d-block w-100" alt="..." />

                            <div className="home__img_img0">
                                <img src="https://cdn2.unrealengine.com/season-bug-en-200x200-dfb08d0feb71.png" alt="" />
                            </div>
                        </div>


                    </div>
                    <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Previous</span>
                    </button>

                    <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Next</span>
                    </button>

                </div>

            </div>
            <div className="mid__img">
                <div className="images__mid">
                    <Bounce left duration={2000}>

                        <img src="https://cdn2.unrealengine.com/18br-fortnitemares-1920x1080-b77ff0e81637.jpg" alt="" />
                    </Bounce>
                    <div className="images__mid__des">
                        <p>
                            FORTNITEMARES 2021: WHAT'S IN YOUR FORTUNE...</p>
                    </div>
                </div>
                <div className="images1__mid">
                    <Bounce right duration={2000}>
                        <img src="https://cdn2.unrealengine.com/15br-fortographyicon-newsthumb-576x576-orange-576x576-1d6e001f6f80.jpg" alt="" />
                    </Bounce>




                    <div className="images1__mid__des">
                        <p>
                            SHOW US YOUR FORTNITEMARES FILMS <br /> FOR VIDEO FORTOGRAPHY !</p>
                    </div>

                </div>
            </div>

            <div className="images_in_row">

                <div className="images_in_row_img">
                    <Bounce bottom duration={1000}>
                        <img src="https://cdn2.unrealengine.com/18br-fortnitemares-tarotflip-week1-newsthumb-576x576-56bafe4ba037.jpg" alt="" />
                    </Bounce>

                    <Bounce bottom duration={2000}>
                        <img src="https://cdn2.unrealengine.com/18br-fiendhunterdualies-thumb-576x576-7724201c211f.jpg" alt="" />
                    </Bounce>

                    <Bounce bottom duration={3000}>
                        <img src="https://cdn2.unrealengine.com/18br-subs-firstshadows2-social-blog-thumb-576x576-47c2d82e2654.jpg" alt="" />
                    </Bounce>

                    <Bounce bottom duration={4000}>
                        <img src="https://cdn2.unrealengine.com/17cr-soundwavehamaki-announce-newsthumb-en-576x576-c13c70ae385b.jpg" alt="" />
                    </Bounce>
                </div>

                <div className="images_in_row_des">
                    <div className="images_in_row_des_all">
                        <Bounce bottom duration={1000}>
                            <p>  <strong>
                                OCT 6, 2021
                            </strong>
                                <br />
                                THE FIENDS HINTED BY THE FORTNITEMARES CARDS
                            </p>
                        </Bounce>
                        <Bounce bottom duration={2000}>
                            <p>

                                <strong>
                                    SEP 28, 2021
                                </strong>
                                <br />
                                HOTFIX: THE DUAL FIEND HUNTERS ENTER THE FRAY IN BR
                            </p>
                        </Bounce>
                        <Bounce bottom duration={3000}>
                            <p>
                                <strong>
                                    NOV 26, 2021
                                </strong>
                                <br />
                                CHAOS ORIGINS TAKES SHAPE IN FORTNITE <br />
                                CREW FOR OCTOBER
                            </p>
                        </Bounce>
                        <Bounce bottom duration={4000}>
                            <p>
                                <strong>
                                    DEC 31, 2021
                                </strong>
                                <br />
                                FORTNITE PRESENTS THE SOUNDWAVE SERIES

                            </p>
                        </Bounce>
                    </div>
                </div>

            </div>
            <div className="loadMore__btn">
                <Flip bottom duration={1000} delay={2000}>
                    <button >
                  LOAD MORE
                    </button>
                </Flip>
            </div>

            {/* home image last */}

            <div className="home__image__last">
                <div className="home__image__last__img" >
                    <img src="https://cdn2.unrealengine.com/hpbp-1920x1184-41c9b87ff66a.jpg" alt="" />
                </div>

                <div className="home__image__last__logo1" >
                    <img src="https://pngimg.com/uploads/fortnite/fortnite_PNG25.png" alt="" />
                </div>

                <div className="home__image__last__logo2" >
                    <img src="https://cdn2.unrealengine.com/cubed-logo-en-763x198-a0ecb436bcc5.png" alt="" />
                </div>
                <Bounce bottom duration={2000}>
                    <div className="home__image__last__battelPass">
                        <p >BATTLE PASS</p>
                    </div>
                </Bounce>


                <Flip bottom duration={2000}>
                    <div className="home__image__last__btn">

                        <h1>PLAY FREE NOW!</h1>
                    </div>
                </Flip>
            </div>
        </>

    )
}

export default Home
